module.exports = __webpack_public_path__ + "static/media/sobhi21.410a59fb.jpg";